import { useNavigate } from 'react-router-dom';

import { Routes } from 'constants/routes';

type SearchArg = string | number | null;

export interface IPropertySearchParams {
    [key: string]: SearchArg | undefined;
    sortBy?: SearchArg;
    sortOrder?: SearchArg;
    status?: SearchArg;
    /** This is apparently what is referred to as the search term in 'useSearchQuery()' */
    q?: SearchArg;
}

/**
 *
 * @returns functor that creates callback to navigate to the lead profile page
 */
export const usePropertyUrl = (params?: IPropertySearchParams) => {
    const navigate = useNavigate();
    const searchString = params
        ? `${Object.keys(params)
              .filter((key) => params[key] !== null)
              .map((key) => `${key}=${params[key]}`)
              .join('&')}`
        : '';

    return (propertyId: string | number) => () => {
        const route = `${Routes.PROPERTY.replace(
            /:[a-zA-Z-]*/u,
            propertyId.toString()
        )}`;
        navigate(`${route}${searchString ? '?' : ''}${searchString}`);
    };
};
